/**
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

/**
 * @class PostMessageReceiver
 *
 * Abstraction-layer for receiving data from &quot;message&quot; events created by
 * window.postMessage, which should be sent from another window&#x27;s
 * PostMessageSender object.
 */

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:29.673Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:base': []
})(this, function (m_module, _, $) {

var M = m_module.M;

"use strict";

  /**
   * Create a new PostMessageReceiver.
   */
  M.PostMessageReceiver = function() {
    this.actions = {};
    _.bindAll(this, '_globalReceiver', 'receive');
    $(window).bind('message', this._globalReceiver);
    return this;
  };

  /**
   * Interpret a "message" event and calls its action-specific receiver.
   *
   * @param {Object} event jQuery event
   */
  M.PostMessageReceiver.prototype._globalReceiver = function(event) {
    // TODO: error handling
          
    try {
      var message = JSON.parse(event.originalEvent.data);

      M.assert(_.isFunction(this.actions[message.action]));
      this.actions[message.action].apply(null, message.args);
    } catch (e) {
      // Empty Catch to reduce Error Noise due to invalid JSON coming from Tag Manager.
      // See:
      // https://minted.atlassian.net/browse/EC-9406
      // https://minted.atlassian.net/browse/EC-11542

    }
  };

  /**
   * Creates a receiver to call when messages are sent to this window.
   *
   * @param {String} action Name of the receiver function, used by send.
   * @param {Function} callback Receiver function called by send.
   *
   * @example
   * messageReceiver.receive('alert', function(message) {
   *   window.alert(message);
   * });
   * messageSender.send('alert', 'hello world'); // From another window.
   */
  M.PostMessageReceiver.prototype.receive = function(action, callback) {
    M.assert(_.isString(action));
    M.assert(_.isFunction(callback));
    this.actions[action] = callback;
  };

return {
};

});
